import { render } from "./SearchableList.vue?vue&type=template&id=fc65e65a&scoped=true"
import script from "./SearchableList.vue?vue&type=script&lang=js"
export * from "./SearchableList.vue?vue&type=script&lang=js"

import "./SearchableList.vue?vue&type=style&index=0&id=fc65e65a&scoped=true&lang=css"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc65e65a"]])

export default __exports__